import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import OptionThumb from "./OptionThumb";

class OptionList extends React.Component {
  render() {
    const sortedOptionsList = this.props.options.sort((a, b) => {
      return a.sort_order - b.sort_order;
    });

    const optionsList = sortedOptionsList.map((option) => {
      return (
        <OptionThumb
          key={option.id}
          isSelected={this.props.design.original_option_id === option.id}
          option={option}
          onOptionClick={this.props.onChooseOption}
        />
      );
    });

    return (
      <div className="tool tool--shape">
        <h4 className="tool__header">Product Style</h4>
        <div className="tool__options">{optionsList}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
  };
}

OptionList.propTypes = {
  options: PropTypes.array.isRequired,
  onChooseOption: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(OptionList);
